const ConsultationSection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title1: "Let’s have a",
      title2: "private",
      title3: "conversation.",
      p1:
        "Every great financial decision starts with an honest conversation. Whether you are exploring your options for the first time, reviewing an existing plan, or looking for specialist guidance on a complex financial matter — we are here to listen, with no obligation and no pressure.",
      p2:
        "Reach out through whichever channel suits you best. We will respond promptly and match you with the advisor best suited to your needs.",
    },

    zh: {
      title1: "让我们进行一次",
      title2: "私密",
      title3: "交流",
      p1:
        "每一个重要的财务决定，都始于一次真诚的交流。无论您是首次咨询、想要检视现有计划，还是需要专业建议，我们都会耐心倾听，没有压力，没有义务。",
      p2:
        "请选择最适合您的方式联系我们，我们会尽快回复，并为您安排最合适的顾问。",
    },
  };

  return (
    <section className="py-10 bg-white">

      <div className="max-w-[1000px] mx-auto px-6 text-center">

        <h2 className="text-[34px] font-medium text-[#154059] leading-snug">

          {text[lang].title1}{" "}
          <span className="text-[#C69C6D]">
            {text[lang].title2}
          </span>{" "}
          {text[lang].title3}

        </h2>


        <p className="text-gray-600 mt-5 leading-relaxed text-[15px]">
          {text[lang].p1}
        </p>

        <p className="text-gray-600 mt-4 leading-relaxed text-[15px]">
          {text[lang].p2}
        </p>

      </div>

    </section>
  );
};

export default ConsultationSection;